// Copyright ©️ 2026 eVolve MEP, LLC

import { HttpStatusCode, isAxiosError, isCancel } from 'axios';

/** Used to check if an error thrown in an axios request was due to a cancellation. */
export const isCanceledApiRequest = isCancel;

/** Ignores errors caused by canceled API requests. Throws all other errors. */
export const ignoreCanceledApiRequest = (error: unknown) => {
  if (isCanceledApiRequest(error)) return;
  throw error;
};

/** Used to check if an error thrown in an axios request was a 400 Bad Request, e.g. a backend validation failure. */
export const isBadRequest = (error: unknown) =>
  isAxiosError(error) && error.response?.status === HttpStatusCode.BadRequest;

/** Used to check if an error thrown in an axios request was a 404 Not Found, e.g. the entity no longer exists. */
export const isNotFound = (error: unknown) => isAxiosError(error) && error.response?.status === HttpStatusCode.NotFound;
